import { Database, Globe } from 'lucide-react';
import { cn } from '../../lib/utils';

interface SilkIconProps {
  className?: string;
  size?: number;
}

export function SourceIcon({ kind, className, size = 18 }: { kind: 'pmtiles' | 'geojson' } & SilkIconProps) {
  const isPMTiles = kind === 'pmtiles';
  
  return (
    <div className={cn(
      "flex items-center justify-center rounded-lg border shadow-sm",
      isPMTiles 
        ? "bg-blue-500/10 border-blue-500/20 text-blue-600 dark:text-blue-400" 
        : "bg-emerald-500/10 border-emerald-500/20 text-emerald-600 dark:text-emerald-400",
      "h-9 w-9 shrink-0",
      className
    )}>
      {isPMTiles ? <Database size={size} /> : <Globe size={size} />}
    </div>
  );
}

export function StatusIndicator({ status, className }: { status: 'success' | 'warning' | 'error' | 'pending' } & SilkIconProps) {
  return (
    <div className={cn(
      "flex h-2 w-2 rounded-full",
      status === 'success' && "bg-emerald-500 shadow-[0_0_8px_rgba(16,185,129,0.5)]",
      status === 'warning' && "bg-amber-500 shadow-[0_0_8px_rgba(245,158,11,0.5)]",
      status === 'error' && "bg-destructive shadow-[0_0_8px_rgba(239,68,68,0.5)]",
      status === 'pending' && "bg-blue-500 animate-pulse",
      className
    )} />
  );
}
